import { render, staticRenderFns } from "./chooseBusinessPriceDetail.vue?vue&type=template&id=36838e2e&scoped=true"
import script from "./chooseBusinessPriceDetail.vue?vue&type=script&lang=js"
export * from "./chooseBusinessPriceDetail.vue?vue&type=script&lang=js"
import style0 from "./chooseBusinessPriceDetail.vue?vue&type=style&index=0&id=36838e2e&prod&lang=scss"
import style1 from "./chooseBusinessPriceDetail.vue?vue&type=style&index=1&id=36838e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36838e2e",
  null
  
)

export default component.exports